module.exports = __webpack_public_path__ + "img/pH_ORP_D_T-7000.86a4dccc.webp";